import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getAccountingStepByStepCoop(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "Na úvod podrobně sp[[zanalyzujeme]] vaši aktuální situaci s účetnictvím a dalšími firemními procesy. Na základě toho doporučíme sp[[ideální postup]] a odhalíme slabiny, které by jinak zůstaly skryté.",
		},
		{
			desc: `Jakmile si odsouhlasíme postup a podmínky spolupráce, sp[[pustíme se do vývoje]], propojení jednotlivých systémů nebo digitalizace a automatizace.`,
		},
		{
			desc: "Doladíme s vámi detaily a spustíme tzv. sp[[MVP]] (Minimum viable product – produkt, který splňuje primární cíle, je spustitelný a životaschopný). Na základě MVP můžeme řešení dále rozvíjet a vylepšovat ho.",
		},
		{
			desc: "Budeme vám k ruce s sp[[podporou]], dalším rozvojem softwaru nebo s řešením nejasností po přechodu na nový účetní systém. ",
		},
	];
}
